import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    show: Boolean
  }

  connect() {
    this.element.classList.remove('hidden')

    // Let external elements toggle the drawer
    document.querySelector(`[data-toggle="#${this.element.id}"]`)?.addEventListener('click', () => this.toggle())
  }

  toggle() {
    this.showValue = !this.showValue
    document.body.classList.toggle('overflow-hidden')
  }
}
